import { Box, Typography, Stack } from "@mui/material";
import ReactEcharts from "echarts-for-react";




export default function GraphCard({ option, height = "50vh", children, cardDetails, onMetricClick }) {



  const empty = !children && !(option?.series?.some(s => Array.isArray(s.data) && s.data.length > 0));
  console.log(empty, 'emptydd');


  if (empty) {
    return (
      <Box
        sx={{
          flex: 1,
          borderRadius: 2,
          p: 2,
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {option?.title?.text && (
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#555' }}>
            {option.title.text}
          </Typography>
        )}
        <Box sx={{ width: '100%', height, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: 600, color: '#999' }}>
          No data available
        </Box>
      </Box>
    );
  }


  return (
    <Box
      sx={{
        flex: 1,
        borderRadius: 2,
        p: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        backgroundColor: '#FFFFFF'
      }}
    >
      {children || <ReactEcharts option={option} onEvents={{
        click: (params) => {
          const allowedSentiments = ['Positive', 'Neutral', 'Negative'];

          if (allowedSentiments.includes(params?.name)) {
            onMetricClick(params.name);
          }
        },
      }}
        style={{ height, width: '100%' }} opts={{ renderer: 'svg' }} />}
    </Box>
  );


}




